module.exports = __webpack_public_path__ + "static/media/telethon-kids-2025.a15922e5.png";